import { FC } from 'react';
import { LabelTransformer, DiffBase, DiffBaseProps } from '../diff-base';
import * as Styled from './org-unit-candidate-preoffer-info-diff.styles';
import { useTranslation } from 'react-i18next';
import { OrgUnitCandidatePreofferInfoDataFields } from '@innowise-group/core';

interface OrgUnitCandidatePreofferInfoDiff extends Omit<DiffBaseProps, 'labelTransformer'> {
  fieldName: OrgUnitCandidatePreofferInfoDataFields;
}

const OrgUnitCandidatePreofferInfoDiff: FC<OrgUnitCandidatePreofferInfoDiff> = (props) => {
  const { fieldName } = props;
  const labelTransformer: LabelTransformer<typeof fieldName> = ({ data }, index) => {
    const { t } = useTranslation();

    return (
      <Styled.OptionWrapper key={index}>
        <Styled.LabelAndValueWrapper>
          <Styled.Value>{data.orgUnitName || t('buttons.leaveBlank')}</Styled.Value>
        </Styled.LabelAndValueWrapper>
      </Styled.OptionWrapper>
    );
  };
  return <DiffBase labelTransformer={labelTransformer} {...props} />;
};

export default OrgUnitCandidatePreofferInfoDiff;
